__turbopack_context__.v({
  "contentLeft": "ID88Lq_contentLeft",
  "desktopAnnotations": "ID88Lq_desktopAnnotations",
  "desktopImage": "ID88Lq_desktopImage",
  "heroHeading": "ID88Lq_heroHeading",
  "heroSection": "ID88Lq_heroSection",
  "imageRight": "ID88Lq_imageRight",
  "mobileAnnotations": "ID88Lq_mobileAnnotations",
  "mobileImage": "ID88Lq_mobileImage",
  "waitlistCTA": "ID88Lq_waitlistCTA",
});
